const SERVER_API = 'http://esource.shreegrgoilmill.com/backend/public/api';
export{SERVER_API}; 
//esource